<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title> Suppression d'une phase </v-card-title>
    <v-card-text> {{ `Voulez vous vraiment supprimer la phase ${payload.phase.name}` }}? </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click.stop="cancel">Annuler</v-btn>
      <v-btn color="primary" variant="text" @click.stop="confirm">Supprimer</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { RemoveComposite } from '@/_services/jobs';
import { stepperMixin } from '@/classes/helper/stepperHelper';

export default {
  name: 'PhaseDeleteDialog',
  mixins: [DialogPropsMixin, stepperMixin],
  methods: {
    cancel() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('loading');

      const requests = this.payload.phase.compositesDTO.map(({ compositePrototypeId }) =>
        RemoveComposite(this.$store.getters['submission/getJobId'], compositePrototypeId),
      );

      Promise.all(requests)
        .then(() => {
          this.$store.dispatch('job/destroyPhase', this.payload.phase.id);
        })
        .catch(error => {
          this.$store.dispatch('snackbar/set', error);
        })
        .finally(() => {
          this.updateTotalCost(this.$store.getters['submission/getJobId'])
            .catch(error => {
              this.$store.dispatch('snackbar/set', error);
            })
            .finally(() => {
              this.$emit('loading', false);
              this.$emit('close');
            });
        });
    },
  },
};
</script>
